import { createFileRoute } from '@tanstack/react-router'
import { EducationPageStructured } from '@/components/infoPages/EducationPageStructured'
import { withPublicPageSeo } from '@/modules/seo'

const EducationPageWithSeo = withPublicPageSeo('forEducation', EducationPageStructured)

export const Route = createFileRoute('/for-education')({ component: EducationPageWithSeo })
